<template>
  <div >
    <van-empty v-if="noData" class="custom-image">
      <template #image> <img :src="emptyimg" alt="" /> </template>
      <p class="empty_tip_1">暂无直播</p>
      <p class="empty_tip_2">逛逛其他精彩直播吧</p>
    </van-empty>
    <van-list
      v-else
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      finished-text="到底啦 ~"
    >
      <div class="meetinglist">
        <!-- <div > -->
        <div
          v-for="(item, index) in meetingList"
          :key="index"
          class="meetinglist_item"
        >
          <!-- {{ index===0?true:false }} -->
          <!-- <a :href="item.liveAddress"> -->
          <div @click="goMeet(item.liveAddress)">
            <div v-if="item.status == 0" class="livetype livetype_wait">
              <img :src="wait" alt="" />
              <span v-if="item.days">{{ item.days }}天后开播</span>
              <span v-else-if="item.isAfter">待开播</span>
              <countdown
                v-else
                :endTime="item.startTime"
                @reload="getMeetingList()"
              ></countdown>
            </div>
            <div
              v-if="item.status == 1 || item.status == 2"
              class="livetype livetype_live"
            >
              <img :src="live" alt="" /> <span>直播中</span>
            </div>
            <div v-if="item.status == 3" class="livetype livetype_back">
              <img :src="back" alt="" /> <span>直播回顾</span>
            </div>
            <div
              v-if="item.status == 4 || item.status == 5"
              class="livetype livetype_end"
            >
              <img :src="end" alt="" /> <span>已结束</span>
            </div>
            <div class="item_img">
              <img
                v-lazyload="
                  item.videoBackgroundImageId
                    ? IMAGE_API + item.videoBackgroundImageId
                    : item.afterMeetingImage
                    ? IMAGE_API + item.afterMeetingImage
                    : defaultImg
                "
                :src="defaultImg"
                alt=""
              />
            </div>
            <div class="item_title">
              <img :src="fire" alt="" v-if="isTop" class="hot_img" />
              {{ item.name }}
              <!-- <p v-else>
                <img :src="fire" alt="" v-if="item.isTop" />
                {{ item.name }}
              </p> -->
            </div>
          </div>
          <!-- </a> -->
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { getMeetingList } from "../request/request";
import { IMAGE_API } from "../request/api";
import Countdown from "./countdown.vue";
import moment from "moment";
export default {
  props: {
    livetype: String,
    isTop: {
      type: Boolean,
      required: false,
    }, //是否顶置
    isShowFire: Boolean,
    time: {
      Type: String,
      required: false,
      default: "",
    }, //今日 明日 时间
    threeOptionsIndex: Number,
    transAll: Number,
    type: String,
  },
  components: {
    Countdown,
  },
  mounted() {
    this.getMeetingLists();
  },
  beforUpdated() {
    // console.log(this.meetingList, "list");
  },
  watch: {
    threeOptionsIndex(newValue) {
      console.log(newValue, "0123 取消今天明天回放");
      if (newValue == 3) {
        this.clearData();
        //回顾
        this.getOnlyBackList();
      } else {
        // 重置数据
        this.clearData();
        this.getMeetingLists();
      }
    },
    isTop(newValue) {
      // 重置数据
      this.clearData();
      this.getMeetingLists();
      console.log(this.meetingList, "7878");
    },
  },
  data() {
    const defaultImg = require("../assets/images/home/defaultImage.png");
    const fire = require("../assets/images/home/fire.png");
    const emptyimg = require("../assets/images/home/empty.png");
    const live = require("../assets/newIcon/newIcon1/live2.png");
    const back = require("../assets/images/home/back.png");
    const end = require("../assets/images/home/end.png");
    const wait = require("../assets/images/home/wait.png");

    return {
      IMAGE_API,
      defaultImg,
      fire,
      emptyimg,
      live,
      back,
      end,
      wait,
      meetingList: [],
      originMeetingList: [],
      refreshing: false,
      loading: false,
      finished: false,
      hasNoData: false,
      timer: null,
      leftList: [],
      rightList: [],
      pageWaite: 1,
      pageMeeting: 1,
      pageBack: 1,
      // 直播中 待开播 回放数据
      waiteData: [],
      meetingData: [],
      backData: [],
      // 是否有下页数据
      isMoreWaiteData: true,
      isMoreMeetingData: true,
      isMoreBackData: true,
      // 是否往下请求数据
      isGoMeetingData: true,
      isGobackData: true,
      noData: false, // 是否展示无数据底图
    };
  },
  methods: {
    // 直播回顾
    async getOnlyBackList() {
      this.loading= true
      let { data: backData } = await getMeetingList({
        page: this.pageBack,
        pageSize: 99999999,
        // filterDate: this.time, //日期
        Status: [3, 4], //状态
      });
      this.loading= false
      console.log(backData,'34343434');
      let onlyBackdade = backData.data.filter((item) => {
        return item.status === 3;
      });
      this.meetingList.push(...onlyBackdade);
      if (onlyBackdade.totalElements > 10 * this.pageBack) {
        this.pageBack++;
        this.isMoreBackData = true;
      } else {
        this.isMoreBackData = false;
      }

    },
    //直播中 1 2
    async getMeetingList() {
      let { data: meetingData } = await getMeetingList({
        page: this.pageMeeting,
        pageSize: 20,
        filterDate: this.time, //日期
        Status: [1, 2], //状态
        isTop: this.isTop,
      });
      this.meetingData.push(...meetingData.data);
      if (meetingData.totalElements > 10 * this.pageMeeting) {
        this.pageMeeting++;
        this.isMoreMeetingData = true;
      } else {
        this.isMoreMeetingData = false;
      }
      // 如果请求条数小于十  就继续请求下一个
      if (meetingData.data.length < 10) {
        this.isGoMeetingData = true;
      } else {
        this.isGoMeetingData = false;
      }
    },

    async getWaiteList() {
      //待开播 0
      let { data: waiteData } = await getMeetingList({
        page: this.pageWaite,
        pageSize: 20,
        filterDate: this.time, //日期
        Status: [0], //状态
        isTop: this.isTop,
      });
      this.waiteData.push(...waiteData.data);

      if (waiteData.totalElements > 10 * this.pageWaite) {
        // 如果待直播条数大于 页书*10
        this.pageWaite++;
        // 还有更多
        this.isMoreWaiteData = true;
      } else {
        this.isMoreWaiteData = false;
      }
      if (waiteData.data.length < 10) {
        this.isGobackData = true;
      } else {
        this.isGobackData = false;
      }
    },

    //回放 3  结束 4
    async getBackList() {
      let { data: backData } = await getMeetingList({
        page: this.pageBack,
        pageSize: 20,
        filterDate: this.time, //日期
        Status: [3, 4], //状态
        isTop: this.isTop,
      });
      this.backData.push(...backData.data);
      if (backData.totalElements > 10 * this.pageBack) {
        this.pageBack++;
        this.isMoreBackData = true;
      } else {
        this.isMoreBackData = false;
      }
    },
    async getMeetingLists() {
      // 每次刷新默认 要往下请求
      this.isGoMeetingData = true;
      this.isGobackData = true;
      this.loading = true;

      // 如果直播中有更多 就继续请求直播中数据
      if (this.isMoreMeetingData) {
        await this.getMeetingList();
      }
      // 带直播有更多|&& 直播中请求条数小于10的时候才继续请求待直播
      if (this.isMoreWaiteData && this.isGoMeetingData) {
        await this.getWaiteList();
      }
      if (this.isMoreBackData && this.isGoMeetingData && this.isGobackData) {
        await this.getBackList();
      }
      // 全部数据l
      let arr = [...this.meetingData, ...this.waiteData, ...this.backData];
      let map = new Map();
      arr.forEach((item) => {
        if (!map.has(item.id)) {
          map.set(item.id, item);
        }
      });
      this.meetingList = [...map.values()];
      console.log(this.meetingList,'---------------');
      if(!this.meetingList.length){
        this.noData = true
      }else{
        this.noData = false
      }
      this.loading = false;
    },
    goMeet(address) {
      if (address) {
        location.href = address;
      }
    },
    onLoad() {
      console.log("到底了 执行onLoad");
      this.timer = setTimeout(() => {
        this.loading = true;
        if (this.threeOptionsIndex == 3) {
          if (this.isMoreBackData) {
            this.getOnlyBackList();
          } else {
            this.loading = false;
            this.finished = true;
          }
        } else {
          if (
            this.isMoreWaiteData ||
            this.isMoreMeetingData ||
            this.isMoreBackData
          ) {
            this.getMeetingLists();

            // this.loading = false;
            // this.finished = true;
          } else {
            this.loading = false;
            this.finished = true;
          }
        }
      }, 1000);
    },

    clearData() {
      this.pageWaite = 1;
      this.pageMeeting = 1;
      this.pageBack = 1;
      (this.isMoreWaiteData = true),
        (this.isMoreMeetingData = true),
        (this.isMoreBackData = true);
      this.finished = false;
      this.waiteData = [];
      this.meetingData = [];
      this.backData = [];
      this.meetingList = [];
    },

    formatList(data) {
      let evenList = data.filter((x, index) => {
        return index % 2 == 0;
      });
      let oddList = data.filter((x, index) => {
        return index % 2 != 0;
      });
      this.leftList = evenList;
      this.rightList = oddList;
      return evenList.concat(oddList);
    },
    formatItem(item) {
      // if (item.name.length > 22) {
      //   item.name = item.name.substring(0, 22) + "...";
      // }
      const now = moment();
      if (now.isBefore(item.startTime)) {
        let days = moment.duration(now.diff(moment(item.startTime))).days();

        if (days < 0) {
          item.days = Math.abs(days);
        }
      } else if (now.isAfter(item.startTime)) {
        item.isAfter = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.meetinglist {
  margin: 0;
  margin-top: 6px;
  padding-top: 5px;
  width: 100%;
  height: calc(100% - 10px);
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  column-gap: 10px;
  columns: 2;
  .meetinglist-left,
  .meetinglist-right {
    display: flex;
    flex-direction: column;
  }

  .meetinglist_item {
    width: 336px;
    display: block;
    padding: 0px;
    // break-inside: avoid;
    box-sizing: border-box;
    margin-top: 0px;
    margin-bottom: 10px;
    position: relative;
    .item_bottom {
      margin-bottom: 0px;
    }
    .item_img {
      width: 346px;
      height: 200px;
      border-radius: 8px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .item_title {
      color: #333333;
      font-size: 24px;
      font-family: OPPOSans-B ;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-top:8px;
      p {
        width: 336px;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 28px;
        margin: 0;
      }
    }
    .hot_img {
      // position: absolute;
      // top: 0;
      // left: -7PX;
      width: 24px;
      height: 32px;
      vertical-align: bottom;
      margin-right: 4px;
    }
    .livetype {
      box-sizing: border-box;
      position: absolute;
      top: 10px;
      left: 10px;
      height: 42px;
      padding: 7px 16px;
      border-radius: 21px;
      display: flex;
      align-items: center;
      color: white;
      font-size: 28px;
      font-family: OPPOSans-R ;

      span {
        margin-left: 6px;
      }
    }
    .livetype_live {
      background-color: RGBA(55, 175, 0, 0.8);
      img {
        width: 22px;
        height: 20px;
        color: #ffff;
      }
    }
    .livetype_end {
      background-color: RGBA(0, 0, 0, 0.38);
      img {
        width: 26px;
        height: 26px;
      }
    }
    .livetype_wait {
      background-color: RGBA(255, 175, 0, 0.8);
      img {
        width:32px;
        height: 34px;
      }
    }
    .livetype_back {
      // background-color: RGBA(0, 0, 0, 0.38);
      background-color: rgba(160, 85, 191, 1);
      img {
        width: 24px;
        height: 26px;
      }
    }
  }
}
.meetinglist .meetinglist_item:nth-child(odd) {
  margin-bottom: 30px;
  // padding-bottom: 10px;
}
.finish_text {
  font-size: 24px;
  text-align: center;
  color: #999999;
}
/deep/ .van-cell {
  padding: unset;
}
/deep/ .van-cell::after {
  content: none;
}
/deep/ .van-empty__image {
  margin-top: 200px;
  width: 280px;
  height: 206px;
}
/deep/ .van-empty__bottom {
  p {
    width: 100vw;
    text-align: center;
  }
  .empty_tip_1 {
    font-weight: 500;
    font-size: 35px;
    color: #999999;
    margin-bottom: 0;
  }
  .empty_tip_2 {
    font-weight: 400;
    font-size: 30px;
    color: #cccccc;
  }
}
/deep/ .van-list {
  .van-list__finished-text {
    font-size: 24px !important;
  }
  .van-loading__text {
    font-size: 24px !important;
  }
}
</style>
